<template>
    <PrismicRichText :field="field" class="title-brand" :class="{'title-brand--starts-with-strong': startsWithStrong}" />
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import type {RichTextField} from '@prismicio/types';
    import {PrismicRichText} from '@prismicio/vue';

    const {field} = defineProps<{field: RichTextField}>();

    const startsWithStrong = computed(() => {
        const block = field?.[0];
        if (!block || !('spans' in block)) return false;
        return block.spans.some((span) => span.type === 'strong' && span.start === 0);
    });
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text' as text;

    /* Highlights every strong tag a pill-shaped background */
    .title-brand {
        font-family: var(--joy-font-family-title);
        font-weight: var(--joy-font-weight-normal);
        line-height: var(--joy-line-height-small);
        font-size: 40px;
        margin-bottom: var(--joy-core-spacing-4);
        color: var(--joy-color-neutral-60);

        h1,
        h2 {
            font-size: inherit;
            font-weight: inherit;
        }

        @include mq.screen_sm(min) {
            @include text.getFontBySize(secondary-400);

            margin-bottom: var(--joy-core-spacing-9);
        }

        @include mq.screen_lg(min) {
            font-size: var(--joy-font-size-secondary-800);
        }

        strong {
            display: inline-block;
            position: relative;
            z-index: 1;
            font-weight: var(--joy-font-weight-normal);
            font-family: var(--joy-font-family-title);
            line-height: var(--joy-line-height-small);
            color: var(--joy-color-neutral-0);
            padding: 0 0.25em;

            &::before {
                content: '';
                display: inline-block;
                position: absolute;
                left: 0;
                top: -0.09em;
                height: 1em;
                width: 100%;
                background-color: var(--joy-color-brand-primary-30);
                border-radius: 9999px;
                z-index: -1;
            }
        }

        &--starts-with-strong {
            strong:first-child {
                margin-left: -0.25em;
            }
        }
    }
</style>
